import { EvseTimelineStoreModel } from '@domain/single-site/single-site.models';

export const mergeEvseTimelineStoreModels = (
  newTimeline: EvseTimelineStoreModel,
  oldTimeline?: EvseTimelineStoreModel
): EvseTimelineStoreModel => {
  if (!oldTimeline) {
    return newTimeline;
  }

  return {
    data: [...oldTimeline.data, ...newTimeline.data],
  };
};
